import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Navbar from "./components/Navbar";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Gallery from "./pages/Gallery";
import Watch from "./components/Watch";
import Document from "./pages/Document";
import NotFound from "./pages/404";
import "./App.css";

class App extends Component {

    state = {
        page: "home"
    }

    setPage = (page) => {
        this.setState({ page });
    }

    // Render a page with a normal layout + header
    pageRender(page) {
        return (
            <div className="app">
                <Navbar page={this.state.page} />
                <div className="app-body">
                    {page}
                </div>
                <div style={{ height: "60px" }} />
            </div>
        )
    }

    render() {
        return (
            <Router>
                <Switch>
                    {/* Normal pages */}
                    <Route exact path="/" render={() => this.pageRender(<About setPage={this.setPage} />)} />
                    <Route exact path="/about" render={() => this.pageRender(<Redirect to="/" />)}/>
                    <Route path="/about/:focus" render={({match}) => this.pageRender(<About setPage={this.setPage} match={match} />)} />
                    <Route path="/contact" render={() => this.pageRender(<Contact setPage={this.setPage} />)} />
                    <Route path="/home" render={() => this.pageRender(<Redirect to="/" />)} />
                    <Route path="/applications" render={() => this.pageRender(<Projects setPage={this.setPage} />)} />
                    <Route path="/projects" render={() => this.pageRender(<Redirect to="/applications" />)}/>
                    <Route exact path="/watches" render={() => this.pageRender(<Gallery name="watches" setPage={this.setPage} />)} />
                    <Route path="/document/:doc" component={Document}/>
                    {/* Iframe pages */}
                    <Route path="/watches/:watch" component={Watch} />
                    {/* 404 */}
                    <Route render={() => this.pageRender(<NotFound setPage={this.setPage} />)} />
                </Switch>
            </Router>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js